import React from 'react';
import { StyledDealerName } from './DealerName.styles';

type DealerNameProps = {
  name: string | undefined;
};
// Making ":plus" italic
const DealerName: React.FC<DealerNameProps> = ({ name }) => (
  <>
    {name?.split(' ').map((component, index) => (
      <StyledDealerName
        // eslint-disable-next-line react/no-array-index-key
        key={index}
      >
        {component === ':plus' ? <i>{component}</i> : component}&nbsp;
      </StyledDealerName>
    ))}
  </>
);

export default DealerName;
